var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isKeepAlive)?_c('keep-alive',[_c('router-view',{key:_vm.$route.key})],1):_c('router-view',{key:_vm.$route.key})
}
var staticRenderFns = []

export { render, staticRenderFns }